import { t } from 'i18next';
import { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { IoGlobeOutline, IoLanguage, IoLogoWhatsapp } from 'react-icons/io5';
import { Link, useNavigate } from 'react-router-dom';
import logo from '../assets/images/logo.svg';

const Header = () => {
  const { i18n } = useTranslation();
  const navigate = useNavigate();

  const [currentLang, setCurrentLang] = useState('en');

  const handleLanguage = () => {
    const lang = localStorage.getItem('locale');
    if (lang && lang == 'en') {
      localStorage.setItem('locale', 'ar');
      i18n.changeLanguage('ar');
      setCurrentLang('ar');
      navigate(0);
    } else {
      localStorage.setItem('locale', 'en');
      i18n.changeLanguage('en');
      setCurrentLang('en');
      navigate(0);
    }
  };

  useEffect(() => {
    const lang = localStorage.getItem('locale');
    if (lang && lang == 'ar') {
      i18n.changeLanguage('ar');
      setCurrentLang('ar');
    } else {
      localStorage.setItem('locale', 'en');
      setCurrentLang('en');
    }
  }, []);

  return (
    <div className="h-20 flex items-center justify-center px-4 border-b border-gray-100 relative">
      <a
        href={
          'https://api.whatsapp.com/send/?phone=96550692333&text=Message+from+Launch+Online+Workshop+Register'
        }
        target="_blank"
        rel="noreferrer"
        className="absolute left-5 top-2/4 -translate-y-2/4">
        <IoLogoWhatsapp size={25} className="text-green-500" />
      </a>
      <Link to={'/'}>
        <img src={logo} alt={t('emstellCourse')} className="max-h-11" />
      </Link>

      {/* <button
        onClick={handleLanguage}
        className={`absolute right-5 flex space-x-2 items-center top-2/4 -translate-y-2/4 ${
          currentLang == 'ar' ? 'rtl' : ''
        }`}>
        <IoLanguage size={28} className="text-gray-500" />
        <span className="absolute text-[10px] bg-sky-500 w-[20px] h-[20px] p-2 flex justify-center items-center rounded-full text-white -bottom-[3px] -right-1">
          {currentLang == 'ar' ? 'EN' : 'AR'}
        </span>
      </button> */}

      {/* old lang button */}
      {/* <button
        onClick={handleLanguage}
        className={`absolute right-5 flex space-x-2 items-center border text-gray-700 top-2/4 border-gray-300 bg-white py-1 px-2 rounded-md hover:bg-gray-200 -translate-y-2/4 ${
          currentLang == 'ar' ? 'rtl' : ''
        }`}>
        <IoGlobeOutline />
        &nbsp;
        {currentLang == 'ar' ? 'EN' : 'AR'}
      </button> */}
    </div>
  );
};

export default Header;
